/**
 * This is global owl carousel onChanged listener
 *
 */
var indexHelper = require('../helper/index-helper'),
    eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox'),
    indexLabels = require('../index-labels'),
    constants = require('src/interlock/no-ui/constant/carousel'),
    toggleArrowsVisibility = require('../toggle-arrows-visibility'),

    EVENT_TYPE_DATA_CAROUSEL_ATTRIBUTE = 'event-type',
    PREVIOUS_INDEX_DATA_CAROUSEL_ATTRIBUTE = 'prev-index';

/**
 * Finds a creative of the element and returns it's idenrifier
 * @param  {Object} $element
 * @return {String|undefined}
 */
function getElementCreativeId($element) {
    var $creative = $element.closest('.edm-entry');
    if ($creative && $creative.length > 0) {
        return $creative.attr('id');
    }
}

module.exports = function subscribeChangedEvent($carousel) {

    $carousel.on('changed.owl.carousel', function (event) {
        var $element = $(this);
        var prevIndex = $element.data(PREVIOUS_INDEX_DATA_CAROUSEL_ATTRIBUTE);
        var eventType = $element.data(EVENT_TYPE_DATA_CAROUSEL_ATTRIBUTE);
        var currentIndex = indexHelper.getCorrectIndex(event);
        var count = event.item.count;
        var carouselOptions = $element.data('options');

        if (indexLabels.isEnabled($element)) {
            indexLabels.set($element, currentIndex);
        }

        if (['drag', 'next', 'prev', 'to'].indexOf(eventType) !== -1) {
            //TODO [FIND-1623] Remove this logic for at-a-glance because we don't want it to fire when it appends photos from the ajax call
            if(getElementCreativeId($element) === 'edm-entry-at-a-glance'
                && window.EDMDataStorage.aagChangeSlideSkipPixelFire) {
                window.EDMDataStorage.aagChangeSlideSkipPixelFire = false;
            } else {
                eventToolbox.fireCustomEvent(constants.OWL_CAROUSEL_SWIPE_EVENT_NAME, [
                    getElementCreativeId($element),
                    {
                        carousel_index: currentIndex,
                        carousel_prev_index: prevIndex,
                        carousel_total: count
                    }
                ]);
            }

            $element.data(EVENT_TYPE_DATA_CAROUSEL_ATTRIBUTE, '');
        }
        $element.data(PREVIOUS_INDEX_DATA_CAROUSEL_ATTRIBUTE, currentIndex);

        if (carouselOptions && !carouselOptions.loop) {

            toggleArrowsVisibility(
                $element, currentIndex, indexHelper.getCorrectLastIndexFromCarouselEvent(event)
            );
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/events/changed.js
// module id = 45
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17